"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const safe_1 = __importDefault(require("colors/safe"));
function lpad(str, count, fill = ' ') {
    str = `${str}`;
    while (str.length < count) {
        str = fill + str;
    }
    return str;
}
exports.lpad = lpad;
function rpad(str, count, fill = ' ') {
    str = `${str}`;
    while (str.length < count) {
        str = str + fill;
    }
    return str;
}
exports.rpad = rpad;
// Applies one or more colors to a message, and returns the colorized message.
function applyColors(message, colorList) {
    if (!message) {
        return message;
    }
    if (typeof (colorList) === 'string') {
        message = safe_1.default[colorList](message);
    }
    else {
        for (const color of colorList) {
            message = safe_1.default[color](message);
        }
    }
    return message;
}
exports.applyColors = applyColors;
const MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr',
    'May', 'Jun', 'Jul', 'Aug',
    'Sep', 'Oct', 'Nov', 'Dec'
];
function dateToString(date) {
    const time = [
        (lpad(date.getHours(), 2, '0')),
        (lpad(date.getMinutes(), 2, '0')),
        (lpad(date.getSeconds(), 2, '0'))
    ].join(':');
    return [MONTHS[date.getMonth()], date.getDate(), time].join(' ');
}
exports.dateToString = dateToString;
//# sourceMappingURL=utils.js.map